import {Component} from '@angular/core';
import {ModalComponent} from "../../../utils/modal/modal.component";
import {FormGroup} from "@angular/forms";
import {MdbModalRef} from "mdb-angular-ui-kit/modal";
import {HttpErrorsService} from "../../../../services/utils/http-errors.service";
import {finalize} from "rxjs";
import {CustomerService} from "../../../../services/resources/customer.service";
import {CustomerModel} from "../../../../models/resources/customer.model";
import {CustomerFormComponent} from "../../../forms/customer-form/customer-form.component";
import {CompanyType} from "../../../../enums/company-type";

@Component({
  selector: 'app-new-customer-modal',
  imports: [
    ModalComponent,
    CustomerFormComponent
  ],
  templateUrl: './new-customer-modal.component.html',
  styleUrl: './new-customer-modal.component.scss'
})
export class NewCustomerModalComponent {
  loading: boolean = false
  formGroup: FormGroup | undefined

  parentId: number | undefined;
  parentCustomer: CustomerModel | undefined;

  constructor(
    private modalRef: MdbModalRef<NewCustomerModalComponent>,
    private httpErrorService: HttpErrorsService,
    private customerService: CustomerService
  ) {
  }

  onFormGroupReady(fg: FormGroup) {
    this.formGroup = fg;
    if (this.parentId) {
      fg.patchValue({parentId: this.parentId}, {emitEvent: false});
    }
  }

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    let resource = this.formGroup?.value;

    if (resource.companyType === CompanyType.PERSON) {
      resource.company = resource.person?.name ?? '';
    }
    if (this.parentId) {
      resource.parentId = this.parentId;
    }
    if (resource.parent)
      resource.parentId = resource.parent.id;

    this.customerService
      .create(resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (customer: CustomerModel) => {
          if (this.parentCustomer) {
            let updated = {
              ...this.parentCustomer,
              children: [
                ...this.parentCustomer.children ?? [],
                customer
              ]
            }
            this.customerService.updateModel(updated);
          }
          this.modalRef.close(customer);
        },
        error: (e) => {
          this.httpErrorService.handleError(e);
        },
      });
  }
}
